<template>
  <div class="noticePopup">
    <van-popup
      v-model="hasNoticePopup"
      overlay-class="ann-popup"
      :closeOnClickModal="false"
    >
      <div class="bj">
        <div class="input-container">
          <input
            type="text"
            placeholder="姓名"
            v-model="name"
            @input="name = name.replace(/[^\u4e00-\u9fa5]/g, '')"
          />
          <!-- <input
          type="text"
          v-model="phone"
          placeholder="手机号"
          name="tel"
          @input="phone = phone.replace(/[^\d]/g, '')"
          @blur="validate(phone, 'phone')"
        /> -->
          <input
            type="text"
            placeholder="身份证"
            v-model="idNo"
            name="idCard"
            @input="idNo = idNo.replace(/[^(\dX)]/g, '')"
            @blur="validate(idNo, 'idNo')"
          />
          <input placeholder="备注" type="text" v-model="description" />
        </div>
      </div>
      <div class="close-button" @click="hasNoticePopup = false"></div>
      <div class="footer-btn" @click="handleClick"></div>
    </van-popup>
  </div>
</template>
<script>
import { Popup, Toast } from 'vant'
export default {
  components: {
    'van-popup': Popup
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    popupType: {
      type: String,
      default: 'popup'
    }
  },
  data() {
    return {
      name: '',
      description: '',
      idNo: '',
      phone: '',
      canSubmit: false
    }
  },
  computed: {
    hasNoticePopup: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {},
  methods: {
    handleClick() {
      if (this.canSubmit) {
        this.hasNoticePopup = false
        this.$emit('buttonClick', {
          idNo: this.idNo,
          description: this.description,
          name: this.name
        })
      } else {
        if (!this.name) {
          Toast({ message: '请输入姓名', className: 'myToast' })
        } else {
          Toast({
            message: '请输入正确的身份证号',
            className: 'myToast'
          })
        }
      }
    },
    validate(val, type) {
      if (
        // /^1[3-9]\d{9}$/.test(this.phone) &&
        /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2]\d|3[0-1])\d{3}[\dX]$/i.test(
          this.idNo
        ) &&
        this.name
      ) {
        this.canSubmit = true
      } else {
        switch (type) {
          case 'phone':
            if (!/^1[3-9]\d{9}$/.test(val)) {
              Toast({ message: '请输入正确的手机号', className: 'myToast' })
            }
            break
          case 'idNo':
            if (!/^\d{17}[\d|x]|\d{15}$/i.test(val)) {
              Toast({ message: '请输入正确的身份证号', className: 'myToast' })
            }
            break
          case 'name':
            if (!this.name) {
              Toast({ message: '请输入姓名', className: 'myToast' })
            }

            break
          default:
            break
        }
        this.canSubmit = false
      }

      console.log(val)
    }
  }
}
</script>
<style lang="scss" scoped>
.bj {
  width: 550px;
  height: 806px;
  background: url('./images/dialog_bg.png') no-repeat;
  background-size: cover;
}
.input-container {
  padding-top: 300px;
  padding-left: 70px;
  input {
    width: 410px;
    height: 60px;
    box-sizing: border-box;
    padding-left: 36px;
    border: 1px solid #a4b7f5;
    border-radius: 58px;
    margin-bottom: 10px;
    outline: none;
    &:focus-visible {
      border: 1px solid #ff4662;
    }
  }
}
.close-button {
  position: absolute;
  right: -40px;
  top: 40px;
  width: 36px;
  height: 36px;
  background: url('./images/close.png') no-repeat;
  background-size: 36px auto;
}
.footer-btn {
  height: 100px;
  position: absolute;
  left: 10px;
  right: 0;
  margin: 0 auto;
  bottom: 100px;
}
.noticePopup ::v-deep {
  .van-popup {
    background-color: transparent;
  }
}
</style>
<style>
.ann-popup.van-overlay {
  background-color: rgba(000, 000, 000, 0.5);
}
</style>
